import { TextButton } from '@zillow/constellation-10';
import { REGISTER_TO_VOTE_LINK } from '../../constants/stringConstants';

export function RegisterToVoteLink({ onClick }: { onClick?: () => void }) {
  return (
    <TextButton tone="brand" asChild onClick={onClick}>
      <a href={REGISTER_TO_VOTE_LINK} target="_blank" rel="noopener noreferrer">
        Register to vote
      </a>
    </TextButton>
  );
}
